/**
 * Return true if selection is inside a code block
 *
 * @param {Draft.EditorState} editorState
 * @return {Boolean}
 */
function hasSelectionInBlock(editorState) {
  var selection = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var startKey = selection.getStartKey();
  var currentBlock = contentState.getBlockForKey(startKey);

  return currentBlock.getType() === 'code-block';
}

module.exports = hasSelectionInBlock;



//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-code/lib/hasSelectionInBlock.js
// module id = 388
// module chunks = 0